export default __webpack_public_path__ + "static/media/whiteFlower.30f94688.png";